import { Component, Input, OnInit } from '@angular/core';
import { FilterCheckboxesComponent } from '../../../../../Common/Filter/components/filterCheckboxes/filter-checkboxes.component';
import { FilterTypeStreamContentCheckboxModel } from './stream-content-checkbox.model';

@Component({
    selector: 'agpr-stream-content-checkbox-filter',
    templateUrl: './stream-content-checkbox-filter.component.html',
    styleUrls: [
        '../../../../../Common/Filter/components/filterCheckboxes/filter-checkboxes.component.scss',
        './stream-content-checkbox-filter.component.scss'
    ],
    standalone: false
})
export class StreamContentCheckboxFilterComponent extends FilterCheckboxesComponent implements OnInit {
    @Input() declare filter: FilterTypeStreamContentCheckboxModel;

    addCustom(): void {}

    ngOnInit(): void {
        this.refresh();
    }

    toggleExcludeAll(): void {

    }
}
